module.exports = __webpack_public_path__ + "static/media/bolso (25).6cd90116.jpg";